import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {TaskManagerState} from '@features/task-manager/store/task-manager.reducer';
import {getTaskViewUpdateInfo} from '@features/task-manager/store/task-manager.selector';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';

@Component({
    standalone: false,
    selector: 'particle-task-toolbar',
  templateUrl: './task-toolbar.component.html',
  styleUrls: ['./task-toolbar.component.scss']
})
export class TaskToolbarComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() data: any;
  @Input() isSupportMember = false;
  card: any;
  @Output() openTaskEvent$ = new EventEmitter<string>();
  @Output() actionEvent$: EventEmitter<any> = new EventEmitter();
  isSubTask = false;
  unsubscribe$ = new Subject<void>();
  isGeneratedByXatBot = false;
  constructor(private taskManagerStore: Store<TaskManagerState>) { }

  get taskLabel(): string {
    return this.card?.displayId || this.card?.title || '';
  }

  get parentLabel(): string {
    const parent = this.card?.parentTicket;
    if (!parent) {
      return '';
    }
    return parent.displayId || this.removeEmptyIdPrefix(parent.displayTitle);
  }

  ngOnInit(): void {
    if (this.data.input.card) {
      this.card = this.data.input.card;
      if(this.card) {
        const ticketSource = this.card.fieldValues
          ?.find(f => f.Key === 'TicketSource')
          ?.Value;
        this.isGeneratedByXatBot = ticketSource === 'SupportXatBot';
      }
    }
    this.isSubTask = !!this.card.parentTicket;
    this.subscribeToInvalidatorListener();
  }

  onClosedClicked() {
    this.actionEvent$.emit({id: '', type: 'ClosedClick', card: this.card});
  }
  onHomeClicked() {
    this.actionEvent$.emit({id: '', type: 'HomeClick'});
  }


  openParentTask(parentTicket: any) {
    parentTicket.scope = this.card.scope;
    this.actionEvent$.emit({id: '', type: 'OpenTask', card: parentTicket});
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  openSubtask(pageNo, pageSize = 1) {
    this.actionEvent$.emit({id: '', type: 'OpenToolbarNavigationSubTask', card: this.card, params: {pageNo: pageNo, pageSize: pageSize}});
  }

  // The server puts the number and a dash before the title, so a ticket with no number starts with a bare dash.
  // The spaces around that dash vary ("-{title}", " - {title}"), so drop the dash with any spaces next to it.
  private removeEmptyIdPrefix(displayTitle: string): string {
    const leadingDashWithSpaces = /^\s*-\s*/;
    return (displayTitle || '').replace(leadingDashWithSpaces, '');
  }

  private subscribeToInvalidatorListener() {
    this.taskManagerStore.pipe(select(getTaskViewUpdateInfo)).pipe(takeUntil(this.unsubscribe$)).subscribe(updatedTaskViewInfo => {
      if (updatedTaskViewInfo && updatedTaskViewInfo.card && updatedTaskViewInfo.card.id === this.card.id) {
        this.card = updatedTaskViewInfo.card;
      }
    });
  }

  ngAfterViewInit(): void {

  }
}
